import { render, staticRenderFns } from "./EscortDisplayTable.vue?vue&type=template&id=7bbc844c&scoped=true&"
import script from "./EscortDisplayTable.vue?vue&type=script&lang=js&"
export * from "./EscortDisplayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc844c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
